export enum FileTypeEnum {
  HTML = 'html',
  PDF = 'pdf',
}
